import {Button, Image, Typography} from "antd";
import React,{useEffect, } from "react";
import HeaderText from "./HeaderText";
import Modal from 'react-modal';

import "../css/modal.css" 
import { isEmpty } from "lodash";
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height:'70%',
    width:'36%',
    backgroundColor:'white',
    boxShadow: '1px 2px 14px -2px rgba(0,0,0,0.75)',
    borderRadius:20,
    borderColor:'#D3D3D3',
    borderWidth:'2px',
    overflow:'hidden',
    // padding:'10px 0 10px 0'
    padding:'0',
    paddingRight:'0'
  },
};


const contentWrapperStyles = {
  height:'100%',
  overflowY: 'auto',
  scrollbarWidth: 'thin', // Customize the scrollbar width
  scrollbarColor: 'transparent transparent', // Customize the scrollbar color (transparent in this example)
};
function ModalContainer({children,onClose,onBtnClick,isVisible,modalHeaderText,modalSubHeaderText,isLoading}) {


  useEffect(() => {
    // Add custom scrollbar styling
    const scrollbarStyle = document.createElement('style');
    scrollbarStyle.innerHTML = `
      .modal-content-wrapper::-webkit-scrollbar {
        width: 0rem;
      }
      .modal-content-wrapper::-webkit-scrollbar-track {
        background-color: transparent;
      }
      .modal-content-wrapper::-webkit-scrollbar-thumb {
        background-color: transparent;
      }
    `;
    document.head.appendChild(scrollbarStyle);

    return () => {
      // Cleanup the added styles when the component is unmounted
      document.head.removeChild(scrollbarStyle);
    };
  }, []);



  return (
    <Modal
    
      isOpen={isVisible}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="modal-content-wrapper" style={contentWrapperStyles}>
      <div style={{borderBottom:'2px solid #D3D3D3',marginBottom:10}}>
     <div style={{paddingLeft:'30px',paddingBottom:'10px',backgroundColor:'#36454F',display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
     <div>
      <HeaderText text={modalHeaderText} headingColor={'white'} size={26}/>
      <Typography style={{fontWeight:'600',color:'white',fontSize:'19px',marginTop:isEmpty(modalHeaderText)?10:0,height:isEmpty(modalHeaderText)?40:30}}>{modalSubHeaderText}</Typography>
      </div>
      <div onClick={onClose} style={{marginRight:13,cursor:'pointer'}}>
<text style={{fontSize:25,color:'white',fontWeight:'500'}}>x</text>
      </div>
      </div>

      </div>
      <div style={{padding:'0 25px 0 25px'}}>
        {children}
        </div>
        <div style={{alignItems:'center',display:'flex',justifyContent:'flex-end',marginBottom:30,marginRight:20,marginTop:20}}>
        <Button type="primary" htmlType="submit" style={{width:'30%',height:'50px',marginTop:'8rem'}} disabled={isLoading} loading={isLoading} onClick={onBtnClick}>
          Save
          </Button>
          </div>
      </div>

  </Modal>
  );
}

export default ModalContainer;
